// Section file — dash-core team (es-419, tuteo). Sections: sidebar, dashboard, settings, magnet, booster, dailyBonus.
import React from "react";

const lang = {
  sidebar: {
    linkAccount: "Vincular cuenta",
    signedInAs: "Sesión iniciada como",
    upgradeYourAccount: "Mejora tu cuenta",
    addAnotherProfile: "Agregar otro perfil",
    accountSettings: "Configuración de la cuenta",
    billing: "Facturación",
    logOut: "Cerrar sesión",
    upgradeNowToPro: "Mejora ahora a Pro",
    followerMagnet: "Imán de Seguidores",
    followerMagnetDesc: "Aumenta tus seguidores automáticamente",
    dailyBonus: "Bono Diario",
    boostTools: "Herramientas de Boost",
    followers: "Seguidores",
    likes: "Me gusta",
    views: "Vistas",
    comments: "Comentarios",
    aiTools: "Herramientas de IA",
    captionGenerator: "Generador de Descripciones",
    ideaGenerator: "Generador de Ideas",
    profileEnhancer: "Optimizador de Perfil",
    trendsAnalyzer: "Analizador de Tendencias",
    photoReviewer: "Evaluador de Fotos",
    instagramTools: "Herramientas de Instagram",
    collabFinder: "Buscador de Colaboraciones",
    storyViewer: "Visor de Historias",
    postDownloader: "Descargador de Publicaciones",
    charts: "Rankings",
    trendingReels: "Reels en Tendencia",
    trendingTiktoks: "TikToks en Tendencia",
    trendingAudio: "Audios en Tendencia",
  },
  dashboard: {
    linkAccount: "Vincular cuenta",
    setPassword: "Establecer contraseña",
    enterPasswordPlaceholder: "Ingresa tu contraseña",
    updatePassword: "Actualizar contraseña",
    pleaseEnterPassword: "Por favor ingresa una contraseña",
	passwordReminderTitle: "Protege tu cuenta.",
	passwordReminderBody: "Establece una contraseña para iniciar sesión con tu correo cuando quieras.",
	passwordReminderAction: "Establecer contraseña",
    loading: "Cargando...",
    signedInAs: "Sesión iniciada como",
    dashboard: "Panel",
    upgradeYourAccount: "Mejora tu cuenta",
    addAnotherProfile: "Agregar otro perfil",
    accountSettings: "Configuración de la cuenta",
    billing: "Facturación",
    logOut: "Cerrar sesión",
    noAccessToken: "No se encontró el token de acceso. Por favor inicia sesión.",
    failedFetchProfile: "No se pudo obtener la información del perfil.",
    unableLoadProfile: "No se pudo cargar el perfil. Inténtalo de nuevo más tarde.",
    tokenInvalid: "El token es inválido o expiró.",
    sessionExpired: "Tu sesión expiró. Por favor inicia sesión de nuevo.",
  },
  settings: {
	passwordSetupHint: "Aún no tienes una contraseña. Establécela ahora para facilitar futuros inicios de sesión.",
    // Function feedback messages
    switchedToMonthly: "¡Tu plan cambió a facturación mensual! Ya no se te cobrará la tarifa anual.",
    errorSwitchingMonthly: "Error al cambiar a mensual. Por favor contacta a soporte.",
    couldNotFindTransaction: "No pudimos encontrar la transacción original. Por favor contacta a soporte.",
    refundedAndSwitched: (amount, monthly, date) => `¡Listo! Te reembolsamos $${amount} y cambiaste a $${monthly}/mes. Próximo cobro: ${date}`,
    errorProcessingSwitch: "Error al procesar el cambio. Por favor contacta a support@viralgpt.com.",
    passwordUpdated: "Tu contraseña ha sido actualizada",
    passwordNotUpdated: "Tu contraseña no se actualizó. Verifica tu contraseña anterior e inténtalo de nuevo.",
    errorUpdatingPassword: "Error al actualizar tu contraseña",
    passwordsDoNotMatch: "¡Las contraseñas no coinciden!",
    profileUpdated: "La configuración de tu perfil se actualizó",
    errorUpdatingProfile: "Error al actualizar tu perfil",
    billingUpdated: "Tu información de facturación ha sido actualizada",
    subscriptionCancelled: "Tu suscripción ha sido cancelada. Ya no se te cobrará.",
    linkedCardChanged: "Tu tarjeta vinculada ha sido cambiada",
    errorLinkingCard: "Error al vincular la tarjeta",
    cardDeleted: "Tu tarjeta ha sido eliminada",
    errorDeletingCard: "Error al eliminar la tarjeta",
    provideReason: "Por favor indícanos el motivo de tu cancelación (mínimo 15 caracteres)",
    subscriptionPaused: "Tu suscripción ha sido pausada",
    errorPausingSubscription: "Error al pausar la suscripción",
    subscriptionResumed: "Tu suscripción ha sido reanudada",
    errorResumingSubscription: "Error al reanudar la suscripción",
    invoicePaid: "Tu factura ha sido pagada",
    errorPayingInvoice: "Error al pagar la factura",
    accountUnlinked: "Tu cuenta ha sido desvinculada",
    errorUpdatingGrowth: "Error al actualizar el estado de crecimiento",
    freeBalanceAdded: "¡Se agregaron $50 a tu saldo!",
    refillSubmitted: (n) => `¡Solicitud de recarga enviada con éxito! ${n} seguidores serán entregados dentro de 24 horas.`,
    errorSubmittingRefill: "Error al enviar la solicitud de recarga",
    scannedMissing: (n) => `Tu perfil ha sido escaneado. Seguidores faltantes: ${n}`,
    scannedNoMissing: "Tu perfil ha sido escaneado. ¡No se encontraron seguidores faltantes!",
    refillNotYet: "Tu pedido reciente aún se está asentando — vuelve en unos días y te recargamos gratis si todavía faltan seguidores.",
    noFollowersDelivered: "Aún no se han entregado seguidores para este perfil.",
    // Page chrome
    title: "Configuración",
    subtitle: "Administra tu cuenta, facturación y suscripciones.",
    tabs: { profile: "Cuenta", billing: "Facturación", invoices: "Facturas", refills: "Recargas" },
    // Account tab
    accountInformation: "Información de la cuenta",
    accountDeleted: "Cuenta eliminada",
    emailAddress: "Correo electrónico",
    enterYourEmail: "Ingresa tu correo",
    preferredLanguage: "Idioma preferido",
    saveChanges: "Guardar cambios",
    changePassword: "Cambiar contraseña",
    linkedProfiles: "Perfiles vinculados",
    unlink: "Desvincular",
    addAnotherProfile: "Agregar otro perfil",
    // Billing tab
    paymentMethods: "Métodos de pago",
    addCard: "Agregar tarjeta",
    expires: (exp) => `Vence ${exp}`,
    linkedToActiveSub: "Vinculada a una suscripción activa",
    deleteCard: "Eliminar tarjeta",
    cardNumber: "Número de tarjeta",
    expiration: "Vencimiento",
    cvc: "CVC",
    // Plan de reposición automática. Tarjeta propia en Facturación, con una
    // cancelación de un solo clic.
    autoRefillTitle: "Reposición automática",
    autoRefillEvery: (d) => `cada ${d} días`,
    autoRefillNext: (date) => `Próximo cobro ${date}`,
    autoRefillActive: "Activa",
    autoRefillCanceled: "Cancelada — tus seguidores permanecen en tu cuenta",
    autoRefillCancel: "Cancelar reposición",
    autoRefillResume: "Reanudar",
    autoRefillConfirm: "¿Cancelar la reposición automática? Conservas todos los seguidores ya entregados y no se te volverá a cobrar.",
    autoRefillCanceledOk: "Reposición automática cancelada. No se te volverá a cobrar.",
    autoRefillResumedOk: "Reposición automática reanudada.",
    autoRefillError: "No se pudo actualizar la reposición automática. Inténtalo de nuevo.",
    subscriptions: "Suscripciones",
    cancelled: "CANCELADA",
    inactive: "INACTIVA",
    noPlan: "SIN PLAN",
    growthPaused: "CRECIMIENTO PAUSADO",
    expiresIn: "Expira en",
    daysRemaining: "Días restantes",
    daysCount: (n) => `${n} días`,
    nextCharge: "Próximo cobro",
    interval: "Intervalo",
    started: "Inicio",
    na: "N/D",
    payInvoice: "Pagar factura",
    selectCard: "Seleccionar tarjeta",
    upgradeToPro: "Mejorar a Pro",
    resumeGrowth: "Reanudar crecimiento",
    pauseGrowth: "Pausar crecimiento",
    cancel: "Cancelar",
    resume: "Reanudar",
    purchasePlan: "Comprar plan",
    // Invoices tab
    invoiceHistory: "Historial de facturas",
    invoiceTh: "Factura",
    profileTh: "Perfil",
    amountTh: "Monto",
    dateTh: "Fecha",
    statusTh: "Estado",
    payNow: "Pagar ahora",
    noInvoicesFound: "No se encontraron facturas",
    invoiceNum: (id) => `Factura #${id}`,
    // Refills tab
    requestRefillTitle: "Solicitar una recarga de seguidores",
    refillDesc1: "Solicita una recarga si perdiste seguidores durante tu período de suscripción.",
    refillDesc2: "Esto no es para recargar boosts instantáneos.",
    selectProfile: "Seleccionar perfil",
    chooseProfile: "Elige un perfil...",
    scanning: "Escaneando...",
    scanProfile: "Escanear perfil",
    scanResults: "Resultados del escaneo",
    noMissingFollowers: "¡No faltan seguidores!",
    current: "Actual",
    gainedVia: "Ganados con ViralGPT",
    expected: "Esperados",
    missing: "Faltantes",
    missingCount: (n) => `Faltan ${n} seguidores`,
    submitting: "Enviando...",
    requestFollowerRefill: "Solicitar recarga de seguidores",
    // Pay Invoice modal
    payInvoiceTitle: "Pagar factura",
    reactivateNote: "Tu suscripción se reactivará desde hoy y será válida por los próximos 30 días",
    paymentMethod: "Método de pago",
    addNewCard: "Agregar nueva tarjeta",
    cardNumberPh: "Número de tarjeta",
    cvvPh: "CVV",
    processing: "Procesando...",
    payAmount: (p) => `Pagar $${p}`,
    // Add Card / Link / Unlink modals
    addPaymentMethod: "Agregar método de pago",
    linkAccount: "Vincular cuenta",
    unlinkAccount: "Desvincular cuenta",
    unlinkConfirm: (name) => <>¿Seguro que quieres desvincular <strong style={{color: '#0a2540'}}>{name}</strong>? Esta acción no se puede deshacer.</>,
    unlinkProfileBtn: "Desvincular perfil",
    // Cancel subscription modal
    cancelSubscription: "Cancelar suscripción",
    cancelWhy: "Por favor cuéntanos por qué cancelas. Esto nos ayuda a mejorar nuestro servicio.",
    reason: "Motivo",
    selectReason: "Selecciona un motivo...",
    reasonMissingFollowers: "Seguidores faltantes",
    reasonPriceTooHigh: "El precio es muy alto",
    reasonAccidentalAnnual: "Compré el plan anual por accidente",
    reasonSwitchMonthly: "Prefiero pagar mensualmente",
    reasonOther: "Otro",
    refillOffer: "¡Podemos recargar tus seguidores faltantes gratis!",
    goToRefills: "Ir a Recargas",
    bonusOffer: "¡Nos gustaría ofrecerte un bono gratis por única vez!",
    getFreeBalance: "Obtén $50 de saldo gratis",
    switchMonthlyOffer: (price) => `O cambia a facturación mensual — paga solo $${price}/mes sin compromiso anual.`,
    switching: "Cambiando...",
    switchToMonthly: "Cambiar a mensual",
    switchRefundTitle: "Cambia a mensual + recibe un reembolso",
    refundExplain: (diff, annual, monthly) => <>
      Te reembolsaremos <strong>${diff}</strong> a tu tarjeta (la diferencia entre ${annual} anual y ${monthly}/mes) y te cambiaremos a facturación mensual.
    </>,
    annualChargePaid: "Cargo anual pagado",
    newMonthlyRate: "Nueva tarifa mensual",
    perMo: (p) => `$${p}/mes`,
    refundToCard: "Reembolso a tu tarjeta",
    refundAndSwitch: (d) => `Reembolsar $${d} y cambiar a mensual`,
    switchToMonthlyBilling: "Cambiar a facturación mensual",
    keepPlanOffer: (plan, price) => <>
      En lugar de cancelar, conserva tu plan {plan} por solo <strong>${price}/mes</strong>. Sin más cargos anuales — cancela cuando quieras.
    </>,
    details: "Detalles",
    detailsPlaceholder: "Por favor escribe al menos 15 caracteres...",
    provide15: "Por favor escribe al menos 15 caracteres.",
    charsMin: "Mínimo 15 caracteres",
    keepSubscription: "Mantener suscripción",
    close: "Cerrar",
    // Change password modal
    currentPassword: "Contraseña actual",
    enterCurrentPassword: "Ingresa tu contraseña actual",
    newPassword: "Nueva contraseña",
    enterNewPassword: "Ingresa tu nueva contraseña",
    confirmNewPassword: "Confirmar nueva contraseña",
    confirmNewPasswordPh: "Confirma tu nueva contraseña",
    savePassword: "Guardar contraseña",
  },
  magnet: {
    growthPausedMsg: "Crecimiento pausado. Puedes reanudarlo cuando quieras.",
    growthResumedMsg: "¡Crecimiento reanudado! Los seguidores comenzarán a entregarse dentro de 24 horas.",
    failedUpdateGrowth: "No se pudo actualizar el estado de crecimiento.",
    profileRefreshed: "Perfil actualizado con éxito.",
    failedRefreshProfile: "No se pudo actualizar el perfil.",
    failedSaveSettings: (err) => `No se pudo guardar la configuración: ${err}`,
    addAccount: "Agregar cuenta",
    comparePlans: "Comparar planes",
    manageAddons: "Administrar complementos",
    outstandingInvoice: "Tienes una factura pendiente de este mes.",
    payYourInvoice: "Por favor paga tu factura",
    toContinue: "para seguir usando nuestros servicios.",
    tabMagnet: "Imán",
    tabExtraBoosts: "Boosts Instantáneos",
    tabAiTools: "Herramientas de IA",
    learningPhase: "Fase de aprendizaje:",
    learningPhaseStart: "La entrega de seguidores comenzará dentro de 24 horas.",
    learningPhaseTuning: "Nuestra IA está afinando tu segmentación para que atraigas seguidores de mayor calidad y más comprometidos que realmente encajan con tu nicho.",
    gained24h: "Seguidores ganados en las últimas 24 horas",
    gained7d: "Seguidores ganados en los últimos 7 días",
    gained30d: "Seguidores ganados en los últimos 30 días",
    refillPrompt: "¿Te faltan seguidores? Solicita una recarga gratis",
    here: "aquí",
    statusNoAccount: "Sin cuenta vinculada",
    statusPausedPrivate: "Pausado - Cuenta privada",
    statusGrowthPaused: "Crecimiento pausado",
    statusActive: "ACTIVO",
    noPlanBadge: "SIN PLAN",
    noPlan: "Sin plan",
    activeBadge: "Activo",
    noActiveSubscription: "Sin suscripción activa",
    ratePerDay: (rate, unit) => `${rate} ${unit} / día`,
    subs: "subs",
    subscribers: "suscriptores",
    followersWord: "seguidores",
    startGrowing: "Comienza a crecer",
    upgradePlan: "Mejorar plan",
    boostGrowth: "Impulsar crecimiento",
    updating: "Actualizando...",
    resumeGrowthLink: "Reanudar crecimiento",
    pauseGrowthLink: "Pausar crecimiento",
    projectedGrowth: "Crecimiento proyectado",
    projection: (active, count, unit, time) => <>Tu cuenta {active ? 'alcanzará' : 'podría alcanzar'} <strong style={{color: '#0a2540'}}>{count}</strong> {unit} en {time}.</>,
    monthsCount: (n) => `${n} meses`,
    daysCount: (n) => `${n} días`,
    targetInterests: "Intereses objetivo",
    targetInterestsDesc: "ViralGPT usa IA para reconocer los intereses del usuario a partir de su bio y publicaciones.",
    targetCountries: "Países objetivo",
    targetCountriesDesc: (unit) => `ViralGPT solo segmentará ${unit} de los países seleccionados.`,
    targetDemographics: "Demografía objetivo",
    targetDemoDesc: (unit) => `ViralGPT dirigirá su alcance a más personas dentro del rango de edad y género seleccionados.`,
    yearsRange: (a, b) => `${a} - ${b} años`,
    genderMale: "Masculino",
    genderFemale: "Femenino",
    genderBoth: "Ambos",
    maleDesc: (unit) => `Atraer más ${unit} hombres`,
    femaleDesc: (unit) => `Atraer más ${unit} mujeres`,
    bothDesc: "Segmentar todos los géneros",
    pauseConfirmTitle: "¿Pausar crecimiento?",
    pauseConfirmBody: "La entrega de seguidores se detendrá hasta que la reanudes. Puedes reanudarla cuando quieras desde tu panel.",
    cancel: "Cancelar",
    yesPause: "Sí, pausar",
    interests: {
      global: "Todos",
      fitness: "Fitness",
      travel: "Viajes",
      fashion: "Moda",
      tech: "Tecnología",
      food: "Comida",
      music: "Música",
      art: "Arte",
      gaming: "Gaming",
      photography: "Fotografía",
      sports: "Deportes",
      health: "Salud",
      beauty: "Belleza",
      books: "Libros",
      movies: "Películas",
      pets: "Mascotas",
      business: "Negocios",
      realestate: "Bienes Raíces",
      homedecor: "Decoración del Hogar",
      education: "Educación",
      development: "Desarrollo Personal",
      wellness: "Salud y Bienestar",
      memes: "Memes/Humor",
      nature: "Naturaleza",
      cars: "Autos",
      writing: "Escritura",
      news: "Noticias",
      science: "Ciencia",
      politics: "Política",
      history: "Historia",
    },
    countries: {
      global: "Global",
      us: "Estados Unidos",
      ca: "Canadá",
      mx: "México",
      gb: "Reino Unido",
      au: "Australia",
      nz: "Nueva Zelanda",
      de: "Alemania",
      fr: "Francia",
      es: "España",
      it: "Italia",
      nl: "Países Bajos",
      be: "Bélgica",
      se: "Suecia",
      no: "Noruega",
      dk: "Dinamarca",
      ch: "Suiza",
      at: "Austria",
      pl: "Polonia",
      pt: "Portugal",
      gr: "Grecia",
      ro: "Rumania",
      bg: "Bulgaria",
      hu: "Hungría",
      cz: "Chequia",
      br: "Brasil",
      ar: "Argentina",
      cl: "Chile",
      co: "Colombia",
      pe: "Perú",
      ve: "Venezuela",
      ec: "Ecuador",
      uy: "Uruguay",
      py: "Paraguay",
      bo: "Bolivia",
      cr: "Costa Rica",
      pa: "Panamá",
      do: "República Dominicana",
      gt: "Guatemala",
      sv: "El Salvador",
      hn: "Honduras",
      ni: "Nicaragua",
    },
  },
  booster: {
    // La configuración recordada, resumida bajo la cantidad elegida. Se leen
    // como L.booster.*: pertenecen al panel de Boosts, no a Configuración.
    editOptions: "Editar opciones",
    buyNowAmount: (p) => `Comprar ahora — $${p}`,
    anyGender: "Cualquier género",
    optQuality: "Calidad",
    optCountry: "País",
    optGender: "Género",
    optSpeed: "Velocidad",
    confirmTitle: "Confirma tu boost",
    payNow: (t) => `Pagar $${t}`,
    deliverTo: (handle) => `Entregar a @${handle}`,
    changeAccount: "Cambiar cuenta",
    // El usuario se pide en una ventana que abre el botón, así que el botón
    // nombra ese paso en vez de prometer una compra que aún no puede completar.
    chooseProfile: "Elegir cuenta",
    profileModalTitle: "¿Para qué cuenta es?",
    postModalTitle: "¿Para qué publicación es?",
    profileLookingUp: "Buscando la cuenta...",
    profileNotFound: "No encontramos esa cuenta — revisa el usuario.",
    profileModalContinue: "Continuar",
    useThisAccount: "Usar esta cuenta",
    loadPosts: "Elegir publicaciones",
    loadingPosts: "Cargando publicaciones...",
    serviceLabel: "Servicio",
    postsChosen: (n, max) => `${n} de ${max} publicaciones seleccionadas — la cantidad se reparte en partes iguales.`,
    tierLabelService: (qty, kind) => `${qty} ${kind}`,
    bundleSpread: "Entrega",
    recentPosts: "Publicaciones recientes",
    engagementBundles: "Paquetes de interacción",
    bundleLabel: (l, v) => `${l} likes + ${v} vistas`,
    bundleSub: (p) => `Repartido entre tus publicaciones recientes de ${p}`,
    bundleQueued: "Tu paquete de interacción va en camino.",
    bundleFailed: "No pudimos procesar ese paquete. Intenta de nuevo.",
    addonTitle: "Mejora este boost",
    addonSub: "Extras opcionales aplicados a tu entrega.",
    addonFailed: "No pudimos aplicar esos extras.",
    addons: { fast: { title: "Entrega súper instantánea", sub: "La entrega empieza en segundos." }, female: { title: "Solo seguidoras", sub: "Segmentamos solo mujeres" }, usa: { title: "Solo seguidores de EE. UU.", sub: "Segmentamos cuentas de Estados Unidos" } },
    quickSelect: "Elige una cantidad",
    customAmount: "Cantidad personalizada",
    prefDelivery: "Entrega",
    prefQuality: "Calidad",
		baseFollowers: "Seguidores base",
		upsellLabels: { engagement: "Seguidores extra", views: "Boost Engagement+", likes: "Me gusta automáticos" },
    prefTargeting: "Audiencia",
    prefLocation: "Ubicación",
    postsBoosted: (n) => `${n} ${n === 1 ? "publicación" : "publicaciones"} con boost`,
    viewDetails: "Detalles",
    // Paquete de interacción pagado que no se pudo entregar porque la cuenta
    // estaba privada al comprarlo.
    packNeedsPublic: "Aún no pudimos entregarlo — tu cuenta debe ser pública para que podamos llegar a tus publicaciones. Ponla en público y pulsa Enviar.",
    packBadUsername: "No encontramos esa cuenta. Revisa la ortografía e introduce tu nombre de usuario, no tu nombre visible.",
    packUsernamePrompt: "No encontramos esta cuenta",
    packUsernameHelp: "Introduce tu nombre de usuario (no tu nombre visible) y enviaremos este pedido.",
    packUsernamePlaceholder: "tu.usuario",
    packUsernameSave: "Guardar y enviar",
    packUsernameMalformed: "Eso no parece un nombre de usuario. Usa solo letras, números, puntos, guiones y guiones bajos — sin espacios.",
    packUsernameRequired: "Introduce un nombre de usuario para saber dónde enviar este pedido.",
    packCheckUnavailable: "No pudimos verificar esa cuenta ahora mismo. Inténtalo de nuevo en un minuto.",
    // El botón nombra lo que envía: la mayoría de los pedidos reenviables son
    // likes y vistas, no seguidores. Se busca por el segmento de servicio de
    // boost_type.
    packSendBy: {
      followers: "Enviar seguidores",
      likes: "Enviar likes",
      views: "Enviar vistas",
      comments: "Enviar comentarios",
      engagement: "Enviar interacción",
    },
    packSend: "Enviar pedido",
    packSending: "Enviando...",
    // Aviso en la parte superior del panel cuando un pedido pagado sigue sin
    // entregarse esperando que el cliente ponga su cuenta en público.
    pendingSendTitle: (n) => (n === 1 ? "Tienes 1 pedido esperando ser enviado" : `Tienes ${n} pedidos esperando ser enviados`),
    pendingSendBody: "Tu cuenta debe ser pública para que podamos llegar a tus publicaciones. Ponla en público y pulsa Enviar.",
    pendingSendCta: "Ir al historial de pedidos",
		deliveryInProgressTitle: (order) => `Tus ${order} se están entregando`,
		deliveryStatus: (status) => `Estado: ${status}`,
		deliveryStarting: "Iniciando",
		deliveryInProgress: "Entrega en curso",
    packStillPrivate: "Tu cuenta sigue apareciendo como privada. Ponla en público e inténtalo de nuevo.",
    packSendFailed: "No se pudo enviar en este momento. Inténtalo de nuevo.",
    orderDetails: "Detalles del pedido",
    thAccount: "Cuenta",
    addFundsTitle: "Agregar fondos",
    buyNow: "Comprar ahora",
    addFundsBonus: (n) => `Agrega fondos — recibe $${n} de bono`,
    payingWithBalance: "Pagando con saldo",
    paidAtCheckout: "Pagado",
    waitPrevious: "Por favor espera a que la orden anterior se complete antes de iniciar una nueva.",
    startingDelivery: (type, amount, link, price) => {
      const t = { followers: "seguidores", likes: "me gusta", views: "vistas", comments: "comentarios" }[type] || type;
      return `¡Iniciando entrega de ${t}!\nCantidad: ${amount}\nEnlace de la publicación: ${link}\nCargo: $${price}`;
    },
    failedCreateOrder: (err) => `No se pudo crear la orden: ${err}`,
    noPosts: "No se encontraron publicaciones. Verifica que el nombre de usuario sea correcto o si la cuenta es privada.",
    services: { followers: "Seguidores", likes: "Me gusta", views: "Vistas", comments: "Comentarios" },
    platformLabel: "Plataforma",
    enterUsername: (p) => `Ingresa el nombre de usuario de ${p} aquí`,
    enterUsernameDefault: "Ingresa el nombre de usuario",
    youtubeProfileLink: "Enlace del perfil de YouTube",
    usernameLabel: (p) => `Nombre de usuario de ${p}`,
    postLinkLabel: (p) => `Enlace de publicación de ${p}`,
    followersAmountMin: (min) => `Cantidad de seguidores (Mín: ${min})`,
    likesAmount: "Cantidad de me gusta",
    viewsAmount: "Cantidad de vistas",
    customComments: "Comentarios personalizados (1 por línea)",
    commentsPlaceholder: "Ingresa comentarios personalizados aquí\nUn comentario por línea",
    selectAPost: "Selecciona una publicación",
    pageN: (n) => `Página ${n}`,
    selectPostContinue: "Selecciona una publicación arriba para continuar",
    orderSummary: "Resumen de la orden",
    pricePer: (u) => {
      const t = { follower: "seguidor", like: "me gusta", view: "vista", comment: "comentario" }[u] || u;
      return `Precio por ${t}`;
    },
    quantity: "Cantidad",
    subtotal: "Subtotal",
    proDiscount: "Descuento Pro",
    total: "Total",
    processing: "Procesando...",
    serviceUnavailable: "Servicio no disponible",
    choosePost: "Elige una publicación",
    startBoost: "Iniciar Boost",
    instant: "Instantáneo",
    noPassword: "Sin contraseña",
    avgDeliveryTime: "Tiempo promedio de entrega",
    orderHistory: "Historial de órdenes",
    noOrders: "Aún no hay órdenes",
    thService: "Servicio",
    thLink: "Enlace",
    thCharge: "Cargo",
    thStart: "Inicio",
    thAmount: "Cantidad",
    thRemains: "Restante",
    thStatus: "Estado",
    thDate: "Fecha",
    qty: (v) => `Cant: ${v}`,
  },
  dailyBonus: {
    celebrations: {
      common: ["Bono reclamado", "¡Buen premio!", "Bono diario", "¡Buen golpe!", "¡Ganaste!"],
      rare: ["¡Gran giro!", "¡Gran bono!", "¡Buen acierto!", "¡Premio de suerte!"],
      epic: ["¡Premio enorme!", "¡Golpe increíble!", "¡Recompensa gigante!", "¡Mega bono!"],
      legendary: ["¡JACKPOT!", "¡Premio enorme!", "¡Giro legendario!", "¡Recompensa gigante!"],
    },
    loading: "Cargando…",
    heading: "Giro de Bono Diario",
    sub: "Gira la ruleta — $ agregados directo a tu saldo ✨",
    spinAvailable: "Giro disponible",
    spinsAvailable: "Giros disponibles",
    free: "GRATIS",
    dailySpinReady: "Giro diario listo",
    nextFreeSpin: "Próximo giro gratis mañana",
    lockedTitle: "Giro gratis diario bloqueado",
    lockedSub: "Obtén un giro gratis cada día con Basic o Pro.",
    upgrade: "Mejorar",
    spin: "GIRAR",
    earnedThisMonth: "Ganado este mes",
    oneExtraSpin: "1 giro extra",
    buyNow: "Comprar ahora",
    saveAmount: (n) => `Ahorra $${n}`,
    fiveSpinsPack: "Paquete de 5 giros",
    buyPack: "Comprar paquete",
    addedToBalance: "agregados a tu saldo",
    continue: "Continuar",
  },

  // Oferta de membresía del panel. Solo promete lo que la membresía entrega:
  // saldo mensual y prioridad de entrega.
  membership: {
    heading: "Hazte miembro",
    subheading: "Los miembros reciben saldo cada mes por menos de lo que cuesta comprarlo.",
    perMonth: "/mes",
    bestValue: "Mejor valor",
    balanceEveryMonth: (amount) => `Recibe $${amount} de saldo cada mes`,
    effectiveDiscount: (pct) => `${pct}% de descuento en cada boost instantáneo`,
    plans: {
      growth: {
        name: "Growth",
        cta: "Unirme a Growth",
        features: [
          "Usa el saldo en cualquier boost instantáneo",
          "Entrega prioritaria",
          "Bonos de recarga exclusivos para miembros",
          "Cancela cuando quieras",
        ],
      },
      expert: {
        name: "Expert",
        cta: "Unirme a Expert",
        features: [
          "Todo lo de Growth",
          "Mejor valor por dólar",
          "Entrega de máxima prioridad",
          "Soporte premium",
          "Cancela cuando quieras",
        ],
      },
    },
  },
};

export default lang;
